import React from 'react';
import '@/sass/app.scss';
import Header from 'components/layouts/Header';
import Home from 'components/Home';
import About from 'components/About';
import Project from 'components/Project';
import Contact from 'components/Contact';
import Copyright from 'components/Copyright';

class App extends React.Component<{}> {
  render() {
    return (
      <div className="App">
        <div className="background-container" />
        <Header />
        <div className="content">
          <Home />
          <About />
          <Project />
          <Contact />
          <Copyright />
        </div>
      </div>
    );
  }
}

export default App;
